<!-- @if (mode === 'success') { -->
    @if (data && questionnaire?.exitScreenTemplate) {
      <div class="survey-exit-screen"
        [style.background-color]="data.backgroundColor"
        [style.display]="'flex'" [style.flex-direction]="'column'"
        [style.height]="'auto'"
        [style.justify-content]="data.verticalAlignment"
        [style.align-items]="data.horizontalAlignment">
        <div class="survey-exit-screen-content"
          [style.display]="'flex'" [style.flex-direction]="'column'"
          [style.align-items]="data.horizontalAlignment"
          [style.text-align]="data.textAlign"
          [style.background-color]="data.backgroundColor">

          @if (mode === 'success') {
          @if (data.imageUrl && data.imagePosition === 'top') {
            <div [style.display]="'flex'" [style.justify-content]="data.imageHorizontalAlignment" [style.width]="'100%'">
              <img [src]="data.imageUrl" alt="Exit Screen Logo" [style.width]="data.imageSizePx + 'px'" [style.height]="'auto'"
                [style.object-fit]="'contain'"
                class="survey-exit-screen-content-image"
                 />
            </div>
          }
          }
          <h3 class="survey-exit-screen-content-title m-0 p-0" [style.color]="data.titleColor" [style.font-size]="data.titleFontSize"
            [style.font-family]="data.titleFontFamily"
            [style.font-weight]="data.titleFontWeight">
            @if (mode === 'success') {
              {{ data.title }}
            } @else {
              You have already given your valuable response.
            }
          </h3>
          <p class="survey-exit-screen-content-description m-0 p-0" [style.color]="data.descriptionColor" [style.font-size]="data.descriptionFontSize"
            [style.font-family]="data.descriptionFontFamily"
            [style.font-weight]="data.descriptionFontWeight">
            @if (mode === 'success') {
              {{ data.description }}
            } @else {
              Thank you!
            }
          </p>

          @if (mode === 'success') {
          @if (redirectionOption && showReviewRedirection) {
            <div class="survey-exit-screen-content-redirection">
              @if (reviewProvider) {
                <img class="survey-exit-screen-content-redirection__logo"
                  src="assets/images/logo/google.svg" alt="Google logo" />
              }
              @if (msgToDisplay) {
                <p class="survey-exit-screen-content-redirection__message">{{ msgToDisplay }}</p>
              }
              @if (url) {
                <a class="survey-exit-screen-content-redirection__btn" [href]="url"
                  target="_blank" rel="noopener noreferrer">
                  <i class="bi bi-box-arrow-up-right"></i>
                  Open Google
                </a>
              }
            </div>
          }
          }
          @if (!data.icxBrand) {
            <div class="survey-exit-screen-content-icx-brand">
              <p class="m-0 p-0">Powered by </p>
              <img src="assets/images/logo/ICXBEE.svg" alt="ICXBee logo" />
            </div>
          }
          @if (mode === 'success') {
          @if (data.imageUrl && data.imagePosition === 'bottom') {
            <div [style.display]="'flex'"
              [style.justify-content]="data.imageHorizontalAlignment" [style.width]="'100%'" [style.margin-top]="'16px'">
              <img [src]="data.imageUrl" alt="Exit Screen Logo" [style.width]="data.imageSizePx + 'px'" [style.height]="'auto'"
                [style.object-fit]="'contain'" class="survey-exit-screen-content-image" />
            </div>
          }
          }
        </div>
      </div>
    } 
<!-- } @else if (mode === 'duplicate') {
  <div class="survey-exit-screen"
  >
    <div class="survey-exit-screen-content">
      <h5 class="survey-exit-screen-content-title">You have already given your valuable response.</h5>
      <p class="survey-exit-screen-content-description">Thank you!</p>
    </div>
    <div class="survey-exit-screen-content-icx-brand">
      <p class="m-0 p-0">Powered by </p>
      <img src="assets/images/logo/ICXBEE.svg" alt="ICXBee logo" />
    </div>
  </div>
} -->
